import React, { Component } from 'react';
import GraficoCircular from '../../charts/GraficoCircular';
import SimplePopover from '../../SimplePopover';
import ComponenteCurricular from './ComponenteCurricular';
import Habilidades from './Habilidades';
import PopupNotas from './PopupNotas';
import { AREA_CONHECIMENTO } from '../../../const';

class Acompanhamento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            calculatedTri: (this.props.mediaTRI && this.props.mediaTRI > 0) || (this.props.grade && this.props.mediaTRIEscola && this.props.mediaTRIEscola > 0)
        }
        console.log('this.props', this.props)
    }

    getEmptyStateSemTri() {
        return <div className="edb-left edb-margin-large-top edb-margin-large-bottom">
            <p>Estamos processando sua nota TRI (lê-se “tê-erre-i”) e calibrando as nossas ferramentas baseado nos resultados das provas de todos os alunos. Por isso, precisamos de mais um tempo para apresentar sua nota.</p>
            <p>Você ainda não sabe o que é TRI? Veja o que o Ministério da Educação tem a dizer. <a target="_blank" rel="noopener noreferrer" title="Abrir o portal do MEC numa nova aba" href="http://portal.mec.gov.br/ultimas-noticias/389-ensino-medio-2092297298/17319-teoria-de-resposta-ao-item-avalia-habilidade-e-minimiza-o-chute"><i className="fas fa-external-link-alt"></i></a></p>
        </div>
    }

    getAreaColor(area) {
        // console.log('status ', status)
        if (area === AREA_CONHECIMENTO.HUMANAS) { return "#22BB66"; }
        if (area === AREA_CONHECIMENTO.NATUREZA) { return "#3388BB"; }
        if (area === AREA_CONHECIMENTO.LINGUAGENS) { return "#EEBB11"; }
        if (area === AREA_CONHECIMENTO.MATEMATICA) { return "#EE8800"; }
    }

    render() {
        return (
            <div>
                <div className="edb-row">
                    <div className="edb-col l5 edb-margin-bottom">
                        <div className="edb-large edb-text-bold">NOTA TRI {this.props.simuladoAtual}</div>
                        {/* ************* EmptyState ************** */}
                        {!this.state.calculatedTri && this.getEmptyStateSemTri()}

                        {this.state.calculatedTri && <div className="edb-center edb-margin-top">
                            {!this.props.grade && <SimplePopover content={<PopupNotas titulo="Nota média" unidade="" meuDesempenho={this.props.mediaTRI} minhaEscola={this.props.mediaTRIEscola} escolaReferencia="0" />}>
                                <GraficoCircular content={
                                    <div className="edb-line-height-medium">
                                        <div className="edb-large edb-text-bold">{this.props.mediaTRI}</div>
                                        {this.props.mediaTRI < this.props.mediaTRIEscola && <i className="fas fa-exclamation-triangle adap-text-red edb-padding-small-left"></i>}
                                    </div>}
                                    color="#6D33BB"
                                    percentage={this.props.mediaTRI * 100 / 1000}
                                    starPercentage={0}
                                    indicatorPercentage={this.props.mediaTRIEscola * 100 / 1000}
                                    strokeWidth={16}
                                    size={120} />
                            </SimplePopover>}
                            {this.props.grade && <SimplePopover content={<PopupNotas titulo="Nota média" unidade="" grade={this.props.grade} meuDesempenho={this.props.mediaTRIEscola} minhaEscola={0} escolaReferencia="0" />}>
                                <GraficoCircular content={
                                    <div className="edb-line-height-medium">
                                        <div className="edb-large edb-text-bold">{this.props.mediaTRIEscola}</div>
                                    </div>}
                                    color="#6D33BB"
                                    percentage={this.props.mediaTRIEscola * 100 / 1000}
                                    starPercentage={0}
                                    indicatorPercentage={0}
                                    strokeWidth={16}
                                    size={120} />
                            </SimplePopover>}

                            <div className="edb-text-bold">Nota média</div>

                            <div className="edb-row">
                                {this.props.notasTRI.map((area, index) => {
                                    return <div key={'area_' + area.idKnowledgeArea} className="edb-col s6 l3 edb-margin-bottom">
                                        {!this.props.grade && <SimplePopover content={<PopupNotas titulo={area.txKnowledgeArea} unidade="" meuDesempenho={area.nuScoreTRI} minhaEscola={area.nuScoreTRISchool} escolaReferencia="0" />}>

                                            <GraficoCircular content={
                                                <div className="edb-line-height-small">
                                                    <div className="edb-text-bold">{area.nuScoreTRI}</div>
                                                    {area.nuScoreTRI < area.nuScoreTRISchool && <i className="edb-small fas fa-exclamation-triangle adap-text-red edb-padding-small-left"></i>}
                                                </div>}
                                                color={this.getAreaColor(area.idKnowledgeArea)}
                                                percentage={area.nuScoreTRI * 100 / 1000}
                                                starPercentage={0}
                                                indicatorPercentage={area.nuScoreTRISchool * 100 / 1000}
                                                strokeWidth={10}
                                                size={80} />
                                        </SimplePopover>}
                                        {this.props.grade && <SimplePopover content={<PopupNotas titulo={area.txKnowledgeArea} unidade="" grade={this.props.grade} meuDesempenho={area.nuScoreTRISchool} minhaEscola={0} escolaReferencia="0" />}>

                                            <GraficoCircular content={
                                                <div className="edb-line-height-small">
                                                    <div className="edb-text-bold">{area.nuScoreTRISchool}</div>
                                                </div>}
                                                color={this.getAreaColor(area.idKnowledgeArea)}
                                                percentage={area.nuScoreTRISchool * 100 / 1000}
                                                starPercentage={0}
                                                indicatorPercentage={0}
                                                strokeWidth={10}
                                                size={80} />
                                        </SimplePopover>}
                                        <div className="edb-small">{area.txKnowledgeArea}</div>
                                    </div>
                                }
                                )}
                            </div>
                        </div>}
                    </div>
                    <div className="edb-col l7">
                        <div>
                            <span className="edb-large edb-text-bold edb-margin-small-right">COMPONENTE CURRICULAR</span>
                            <span>| MÉDIA {this.props.mediaComponenteCurricular}%</span>
                        </div>

                        <ComponenteCurricular mediasDisciplina={this.props.mediasDisciplina} grade={this.props.grade} />
                    </div>
                </div>

                <div className="edb-margin-large-top">
                    <span className="edb-large edb-text-bold edb-margin-small-right">COMPETÊNCIAS</span>
                    <span>| DECRESCENTE</span>
                </div>
                <p className="edb-margin-small-top">
                    A lista abaixo está ordenada da debilidade para a competência em relação a distância da sua média para a média da sua escola.
                Os itens com alerta são os que você precisa estudar mais. {/*Use o ícone <i className="fas fa-check-square"></i> para ver exemplos
                de questões sobre esse tema que você respondeu em simulados anteriores. E use o ícone <i className="fas fa-clock"></i> para alocar
                                        estudos sobre esse tema para melhorar seu rendimento.*/}
                </p>

                <Habilidades mediasHabilidade={this.props.mediasHabilidade} grade={this.props.grade} />

            </div>);
    }
}

export default Acompanhamento;